import partner from './partnerEndpoints'
import wordpress from './wordpressEndpoints'

const hasKey = <T extends object>(value: T, key: PropertyKey): key is keyof T =>
  Object.prototype.hasOwnProperty.call(value, key)

export const getQueryEndpoint = (scope: string, key: string) => {
  if (scope === 'partner' && hasKey(partner, key)) {
    const endpoint = partner[key]
    return 'queryFn' in endpoint ? endpoint : undefined
  }
  if (scope === 'wordpress' && hasKey(wordpress, key)) {
    return wordpress[key]
  }
  return undefined
}
